// Logo URLs
export const logos = {
  icon: "/iconos/Solo-Logo-InnovArs.png",
  horizontal: "/iconos/Logo-InnovArs-Horizontal.png",
  vertical: "/iconos/Solo-Logo-InnovArs.png",
};

// Company Info
export const companyInfo = {
  name: "InnovArs Microsistemas",
  tagline: "Tecnología inteligente, soluciones reales",
  subtitle:
    "Diseñamos, desarrollamos y fabricamos soluciones tecnológicas a medida para comercios e industrias",
};

// Contact Info
export const contactInfo = {
  phone: "3564-596712",
  email: "innovars@outlook.com",
  instagram: "@innovars.microsistemas",
  instagramUrl: "https://instagram.com/innovars.microsistemas",
};

// Navigation Links
export const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Servicios", href: "#servicios" },
  { label: "DataStore365", href: "#datastore365" },
  { label: "Portafolio", href: "#portafolio" },
  { label: "Contacto", href: "#contacto" },
];

// DataStore365 Product
export const dataStore365 = {
  name: "DataStore365",
  logo: "/iconos/DataStoreBLANCO.png",
  loginUrl: "https://datastore365.innovars.com.ar",
  description:
    "Sistema de adquisición de datos para monitoreo de ambientes y/o equipos comerciales o industriales, de forma local o remota.",
  features: [
    {
      title: "Monitoreo 24/7",
      desc: "Registro continuo de variables críticas las 24 horas, los 365 días del año.",
      icon: "Activity",
    },
    {
      title: "Acceso Remoto",
      desc: "Consultá tus datos desde cualquier lugar a través de la plataforma web.",
      icon: "Globe",
    },
    {
      title: "Alertas Inteligentes",
      desc: "Notificaciones automáticas cuando los valores superan los límites configurados.",
      icon: "Bell",
    },
    {
      title: "Reportes y Análisis",
      desc: "Generación de reportes detallados y gráficos históricos de tus mediciones.",
      icon: "BarChart3",
    },
    {
      title: "Multi-Sensor",
      desc: "Compatible con múltiples tipos de sensores para temperatura, humedad y más.",
      icon: "Thermometer",
    },
    {
      title: "Instalación Flexible",
      desc: "Soluciones adaptables para cualquier ambiente comercial o industrial.",
      icon: "Settings",
    },
  ],
};

// Services
export const services = [
  {
    id: "embedded",
    title: "Sistemas Embebidos",
    subtitle: "Diseño & Desarrollo",
    description:
      "Diseñamos y desarrollamos sistemas embebidos completos, desde el concepto inicial hasta la fabricación en serie. Soluciones a medida para comercios e industrias.",
    features: [
      { name: "Diseño Electrónico", desc: "Esquemáticos, PCB y simulación" },
      { name: "Desarrollo de Firmware", desc: "Programación de microcontroladores y SoCs" },
      { name: "Prototipado", desc: "Prototipos funcionales rápidos" },
      { name: "Pruebas Funcionales", desc: "Testing completo del sistema" },
      { name: "Validación", desc: "Verificación de cumplimiento" },
      { name: "Fabricación", desc: "Producción en serie" },
    ],
    icon: "Cpu",
  },
  {
    id: "it",
    title: "Informática",
    subtitle: "Soluciones IT",
    description:
      "Servicio integral de informática: desde el armado y venta de computadoras hasta la instalación y configuración de redes empresariales.",
    features: [
      { name: "Armado de PCs", desc: "Equipos personalizados a medida" },
      { name: "Venta de Equipos", desc: "Hardware de primeras marcas" },
      { name: "Reparación", desc: "Diagnóstico y reparación express" },
      { name: "Instalación de Redes", desc: "Cableado estructurado y WiFi" },
      { name: "Configuración", desc: "Setup y optimización de sistemas" },
    ],
    icon: "Monitor",
  },
  {
    id: "audio",
    title: "Sistemas de Audio",
    subtitle: "Audio Profesional",
    description:
      "Venta, diseño y reparación de sistemas de audio profesional. Desde instalaciones residenciales hasta sistemas de sonido para eventos y comercios.",
    features: [
      { name: "Venta de Equipos", desc: "Equipamiento de audio profesional" },
      { name: "Diseño de Sistemas", desc: "Soluciones acústicas a medida" },
      { name: "Reparación", desc: "Servicio técnico especializado" },
    ],
    icon: "Volume2",
  },
];

// Portfolio Projects (mock data)
export const projects = [
  {
    id: 1,
    title: "Control Industrial IoT",
    category: "embedded",
    description:
      "Sistema de monitoreo y control industrial con conectividad IoT para planta de manufactura.",
    image:
      "https://images.pexels.com/photos/163170/board-printed-circuit-board-computer-electronics-163170.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tags: ["IoT", "Firmware", "PCB"],
  },
  {
    id: 2,
    title: "Controlador de Automatización",
    category: "embedded",
    description:
      "Desarrollo de controlador embebido para línea de producción automatizada.",
    image:
      "https://images.pexels.com/photos/326461/pexels-photo-326461.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tags: ["Automatización", "Firmware", "Electrónica"],
  },
  {
    id: 3,
    title: "Infraestructura IT Corporativa",
    category: "it",
    description:
      "Implementación completa de infraestructura de red para oficina corporativa de 50 puestos.",
    image:
      "https://images.pexels.com/photos/4508751/pexels-photo-4508751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tags: ["Redes", "Servidores", "WiFi"],
  },
  {
    id: 4,
    title: "Centro de Datos Empresarial",
    category: "it",
    description:
      "Diseño e implementación de centro de datos con redundancia y alta disponibilidad.",
    image:
      "https://images.pexels.com/photos/5092815/pexels-photo-5092815.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tags: ["Servidores", "Networking", "Seguridad"],
  },
  {
    id: 5,
    title: "Sistema de Sonido para Eventos",
    category: "audio",
    description:
      "Diseño e instalación de sistema de audio profesional para centro de eventos.",
    image:
      "https://images.pexels.com/photos/635928/pexels-photo-635928.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tags: ["Audio Pro", "Instalación", "Diseño"],
  },
  {
    id: 6,
    title: "Estudio de Grabación",
    category: "audio",
    description:
      "Equipamiento y acondicionamiento acústico para estudio de grabación profesional.",
    image:
      "https://images.pexels.com/photos/230868/pexels-photo-230868.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tags: ["Acústica", "Audio", "Diseño"],
  },
];

// Stats
export const stats = [
  { value: "10+", label: "Años de Experiencia" },
  { value: "200+", label: "Proyectos Realizados" },
  { value: "150+", label: "Clientes Satisfechos" },
  { value: "3", label: "Áreas de Servicio" },
];

// Contact form initial state
export const contactFormInitial = {
  name: "",
  email: "",
  phone: "",
  service: "",
  message: "",
};
